import React, { useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.css'
import { Select } from '../../../components/ModalInputs'
import * as Yup from 'yup'
import { getSpecMedGroupsGroups, getSpecMedGroupsStudents, } from '../../../actions/medCenter/specMedGroups'
import Table from '../../../components/Table'
import Button from '../../../components/Button'
import { getQuestionsModal, getQuestionsModalAdd, updateVariant } from '../../../actions/applicantQuestionSet'

const validationSchema = Yup.object({
  name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),

})

export default function ModalComponent({ data, closeModal, height, handleChangeStudents, selectedQuestions, handleUpdateQuestion }) {

  const dispatch = useDispatch()

  const { qustionsModalAdd } = useSelector(state => state.applicantQuestionSet)

  const [selected, setSelected] = useState(null)

  const renderLi = (data) => {
    const { q_num, name, level, weight, q_type, q_name, id } = data
    return (
      <tr
        onClick={() => handleChangeStudents(data)}
        style={{ backgroundColor: selectedQuestions?.find(el => (el.id == id)) ? '#3689FF' : '' }}
      >
        <td>{q_num}</td>
        <td>{name}</td>
        <td>{weight}</td>
        <td>{q_type}</td>
        <td>{q_name}</td>
      </tr>
    )
  }

  const handleChange = (data) => {
    setSelected(data)
  }

  const handleSubmit = () => {
  }


  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      height={height}
      classNames={{
        // overlay: styles.overlay,
        modal: styles.custom
      }}
    >
      <>
        <div className={styles.modalQuestionLocal} >
          <div className={styles.tabWrapper} >
            <Table className={styles.table} >
              <thead>
                <tr>
                  <th>№</th>
                  <th>Дисциплина</th>
                  <th>Сложность</th>
                  <th>Тип</th>
                  <th>Вопрос</th>
                </tr>
              </thead>
              <tbody>
                {qustionsModalAdd?.map(renderLi)}
              </tbody>
            </Table>
          </div>
        </div>
        <div className={styles.inputsRow}>
          <Button style={{ margin: '0 auto 20px' }} onClick={handleUpdateQuestion}>Сохранить</Button>
          <Button style={{ margin: '0 auto 20px' }} onClick={closeModal}>Отменить</Button>
        </div>
      </>
    </Modal>

  )
}
